import React from 'react';
import { motion } from 'framer-motion';
export function Process() {
  const steps = [{
    num: '01',
    title: 'Free Audit',
    desc: 'We analyze your current Google presence and identify missed opportunities.'
  }, {
    num: '02',
    title: 'Setup',
    desc: 'We optimize your profile and integrate our automated review system.'
  }, {
    num: '03',
    title: 'Launch',
    desc: 'Automated review requests go out via SMS and email to recent customers.'
  }, {
    num: '04',
    title: 'Grow',
    desc: 'Reviews flow in, rankings climb, and your phone starts ringing more.'
  }];
  return <section id="process" className="py-20 md:py-32 bg-surface overflow-hidden" data-id="element-288">
      <div className="container mx-auto px-4 md:px-6" data-id="element-289">
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24" data-id="element-290">
          <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-navy mb-4" data-id="element-291">
            Your Reputation Is Our Business
          </h2>
          <p className="text-lg text-muted" data-id="element-292">
            A simple, proven process to turn your happy customers into your best
            marketing asset.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto" data-id="element-293">
          {/* Desktop Horizontal Line */}
          <div className="hidden md:block absolute top-8 left-[10%] right-[10%] h-0.5 bg-gray-200" data-id="element-294">
            <motion.div className="h-full bg-gold" initial={{
            width: '0%'
          }} whileInView={{
            width: '100%'
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 1.5,
            ease: 'easeInOut'
          }} data-id="element-295" />
          </div>

          {/* Mobile Vertical Line */}
          <div className="md:hidden absolute top-0 bottom-0 left-8 w-0.5 bg-gray-200" data-id="element-296">
            <motion.div className="w-full bg-gold" initial={{
            height: '0%'
          }} whileInView={{
            height: '100%'
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 1.5,
            ease: 'easeInOut'
          }} data-id="element-297" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6 relative z-10" data-id="element-298">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="flex md:flex-col items-start md:items-center relative" data-id="element-299">
                <div className="flex-shrink-0 w-16 h-16 rounded-full bg-white border-4 border-surface shadow-md flex items-center justify-center text-xl font-heading font-bold text-navy relative z-10 md:mb-6" data-id="element-300">
                  {step.num}
                </div>
                <div className="ml-6 md:ml-0 md:text-center mt-2 md:mt-0" data-id="element-301">
                  <h3 className="text-xl font-heading font-bold text-navy mb-2" data-id="element-302">
                    {step.title}
                  </h3>
                  <p className="text-muted text-sm" data-id="element-303">{step.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}